import React, { Component, Suspense, lazy } from 'react'
import store from '../../store'
import Helmet from 'react-helmet'
import SuspenseLoader from './../../components/suspense_loader/SuspenseLoader'
import Sidebar from './../../components/sidebar/Sidebar'

import './Scoreboard.scss'
import HeaderTitle from '../shared/HeaderTitle'

const NBAScoreboard = lazy(() => import('./nba/NBAScoreboard'))
const NHLScoreboard = lazy(() => import('./nhl/NHLScoreboard'))
const AHLScoreboard = lazy(() => import('./ahl/AHLScoreboard'))
const MLBScoreboard = lazy(() => import('./mlb/MLBScoreboard'))
const CFLScoreboard = lazy(() => import('./cfl/CFLScoreboard'))
const NFLScoreboard = lazy(() => import('./nfl/NFLScoreboard'))
const WHCScoreboard = lazy(() => import('./whc/WHCScoreboard'))
const OHLScoreboard = lazy(() => import('./ohl/OHLScoreboard'))
const QMJHLScoreboard = lazy(() => import('./qmjhl/QMJHLScoreboard'))
const WHLScoreboard = lazy(() => import('./whl/WHLScoreboard'))
const WJHCScoreboard = lazy(() => import('./wjhc/WJHCScoreboard'))
const CHLScoreboard = lazy(() => import('./chl/CHLScoreboard'))
const NCAAMBScoreboard = lazy(() => import('./ncaamb/NCAAMBScoreboard'))

class Scoreboard extends Component {
    componentDidMount() {
        store.dispatch({
            type: 'ANALYTIC_EVENT_PAGE',
            naming: {
                sport: this.props.match.params && this.props.match.params.sport,
                league: this.props.match.params && this.props.match.params.league,
                page: 'scores',
                url: window.location.href || document.URL,
            },
        })
    }

    render() {
        const { league, sport } = this.props.match.params
        const leagueFormatted = league.toUpperCase()

        return (
            <div className="Scoreboard__cont scoreboard">
                <Helmet
                    title={`${leagueFormatted} Scoreboard - Sportsnet.ca`}
                    link={[
                        {
                            rel: 'canonical',
                            href: `${window.location.origin}/${sport}/${league}/scores`,
                        },
                    ]}
                >
                    <meta
                        name="description"
                        content={`Your source for ${leagueFormatted} schedule and score information.`}
                    />
                    <meta
                        name="og:url"
                        content={`${window.location.origin}/${sport}/${league}/scores`}
                    />
                    <meta
                        name="og:title"
                        content={`${leagueFormatted} Scoreboard - Sportsnet.ca`}
                    />
                    <meta
                        name="og:description"
                        content={`Your source for ${leagueFormatted} schedule and score information.`}
                    />
                    <meta
                        name="og:image"
                        content={`https://images.rogersdigitalmedia.com/www.sportsnet.ca/team_logos/90x90/${sport}/${league}/${league}.png`}
                    />
                </Helmet>

                <div className="inner_cont">
                    <div className="left_col">
                        {(league === 'nhl' ||
                            league === 'ahl' ||
                            league === 'mlb' ||
                            league === 'nba' ||
                            league === 'cfl' ||
                            league === 'nfl' ||
                            league === 'whc' ||
                            league === 'ohl' ||
                            league === 'qmjhl' ||
                            league === 'whl' ||
                            league === 'wjc' ||
                            league === 'chl' ||
                            league === 'ncaamb') && (
                            <HeaderTitle title={league.toUpperCase() + ' Scoreboard'}></HeaderTitle>
                        )}
                        <Suspense fallback={<SuspenseLoader />}>
                            {league === 'nhl' && <NHLScoreboard {...this.props} />}
                            {league === 'ahl' && <AHLScoreboard {...this.props} />}
                            {league === 'mlb' && <MLBScoreboard {...this.props} />}
                            {league === 'nba' && <NBAScoreboard {...this.props} />}
                            {league === 'cfl' && <CFLScoreboard {...this.props} />}
                            {league === 'nfl' && <NFLScoreboard {...this.props} />}
                            {league === 'whc' && <WHCScoreboard {...this.props} />}
                            {league === 'ohl' && <OHLScoreboard {...this.props} />}
                            {league === 'whl' && <WHLScoreboard {...this.props} />}
                            {league === 'qmjhl' && <QMJHLScoreboard {...this.props} />}
                            {league === 'wjc' && <WJHCScoreboard {...this.props} />}
                            {league === 'chl' && <CHLScoreboard {...this.props} />}
                            {league === 'ncaamb' && <NCAAMBScoreboard {...this.props} />}
                        </Suspense>
                    </div>

                    <div className="right_col">
                        <Sidebar league={league} page="Scoreboard" />
                    </div>
                </div>
            </div>
        )
    }
}

export default Scoreboard
